import React, { useContext, useEffect, useMemo, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import api from './../api.js';
import { IndianCurrencyFormatter } from './../Function';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../Staff/Staff.css';

function payBadge(item) {
  if (String(item.is_paid) === '2') {
    return <span className="badge badge-warning">Cancelled</span>;
  }
  if (item.paytype === 'online') {
    return String(item.is_paid) === '0'
      ? <span className="badge badge-success">Paid (Online)</span>
      : <span className="badge badge-warning">Pending (Online)</span>;
  }
  return <span className="badge badge-success">Paid (Cash)</span>;
}

function Index() {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const type = useMemo(() => {
    const value = new URLSearchParams(location.search).get('type');
    return value === 'online' ? 'online' : 'cash';
  }, [location.search]);
  const isTotal = useMemo(() => {
    return new URLSearchParams(location.search).get('scope') === 'total';
  }, [location.search]);
  const isCash = type === 'cash';
  const title = isTotal
    ? (isCash ? 'Total Cash' : 'Total Online')
    : (isCash ? 'Today Cash Sales' : 'Today Online Sales');

  const [summary, setSummary] = useState(null);
  const [bills, setBills] = useState([]);
  const [dateLabel, setDateLabel] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }, [location]);

  const load = async () => {
    setLoading(true);
    try {
      const scope = isTotal ? '&scope=total' : '';
      const response = await api.get(`/vendor/today-sales?type=${type}${scope}`);
      if (response.data.status === 'success') {
        setSummary(response.data.summary || null);
        setBills(response.data.bills || []);
        setDateLabel(response.data.date || '');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) load();
  }, [user, type, isTotal]);

  const cards = isCash
    ? [
        { label: isTotal ? 'Total Cash' : 'Today Cash Sales', value: summary?.amount || 0, money: true },
        { label: isTotal ? 'Total Cash Count' : 'Today Cash Sales Count', value: summary?.count || 0, money: false },
        { label: isTotal ? 'Total Reward Use' : 'Today Reward Use', value: summary?.reward_used || 0, money: true },
      ]
    : [
        { label: isTotal ? 'Total Online Bill' : 'Today Online Bill', value: summary?.amount || 0, money: true },
        { label: isTotal ? 'Total Online Count' : 'Online Bill Count', value: summary?.count || 0, money: false },
      ];

  return (
    <div id="appCapsule" className="staff-page">
      <Footer />
      <Sidebar />
      <div className="section mt-2">
        <div className="section-heading">
          <h2 className="title">{title}</h2>
          <a href="/home" className="link" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            Back
          </a>
        </div>
        {dateLabel ? <div className="text-muted mb-2">{dateLabel}</div> : null}

        {loading ? (
          <div className="text-center p-3">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : summary ? (
          <div className="row staff-summary">
            {cards.map((card) => (
              <div className="col-6 mb-2" key={card.label}>
                <div className="stat-box">
                  <div className="title">{card.label}</div>
                  <div className={`value ${isCash ? 'text-success' : 'text-danger'}`} style={{ fontSize: '16px' }}>
                    {card.money ? <IndianCurrencyFormatter amount={card.value} /> : card.value}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>

      <div className="section mb-5">
        <div className="section-heading">
          <h2 className="title">Bill details</h2>
        </div>
        {bills.length === 0 ? (
          <div className="card">
            <div className="card-body text-center text-muted">{isTotal ? 'No bills found.' : 'No bills for today.'}</div>
          </div>
        ) : (
          <ul className="listview image-listview">
            {bills.map((item) => (
              <li key={item.id}>
                <Link to={`/Payment?id=${item.id}`} className="item">
                  <div className="in" style={{ width: '100%' }}>
                    <div>
                      <strong>#{item.billno}</strong>
                      <div className="text-muted small">{item.date_time}</div>
                      <div className="small">{item.created_by}</div>
                      <div className="small">
                        {item.customer_name || 'Customer'}
                        {item.customer_phone ? ` - ${item.customer_phone}` : ''}
                      </div>
                      <div className="mt-1">{payBadge(item)}</div>
                    </div>
                    <div className="text-end">
                      <div className="price text-danger">
                        <IndianCurrencyFormatter amount={(parseFloat(item.billamount || 0) + parseFloat(item.tax || 0))} />
                      </div>
                      {parseFloat(item.customer_reward_used || 0) > 0 && (
                        <div className="small text-success">
                          Reward <IndianCurrencyFormatter amount={item.customer_reward_used} />
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Index;
